import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import FileUpload from "../../../FileUploads/FileUpload";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import SuccessModal from "../../../CustomModal/Success";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import {lastCheckIn} from "../../../../service/CarService/action";
import useCurrentlocation from "../../../../hooks/currentlocation/useCurrentlocation";

const CarServiceActivitySave = ({
                                     documentUploadUrlPublic,
                                     documentUrlDataPublic = [],
                                     history,
                                     match,
                                     getActivity,
                                     types = [],
                                     senior = [],
                                     getSenior,
                                     activitySave,
                                     saveActivityResponse = [],
                                     isCheckout,
                                     isCheckoutDetails = [],
                                     getPendingActivity,
                                     pendingActivity=[],
                                     markAttendance,
                                     attendance=[],
                                    lastCheckIn,
                                    lastCheckInRes=[],
                                    errorLogs
                                 }) => {
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        meta_data: {},
        lat: '',
        long: '',
        next_activity_type_id: '',
        next_activity_date: '',
        description: '',
        tagged_along: '',
        account_id:'',
        reason:[]
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [checkInText, setCheckInText] = useState('')
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [successMessage, setSuccessMessage] = useState('')
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [reason, setReason] = useState([{}])
    // const [productDiscussed, setProductDiscussed] = useState([{product_discussed:''}])
    const [lastCheckInUrl, setLastCheckInUrl] = useState('')
    const currentLocation = useCurrentlocation();
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [isMockLocation, setIsMockLocation] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getActivity()
            await getPendingActivity(match?.params?.account_id)
            await getSenior()
            await isCheckout('Car Service', match?.params?.account_id)
            await lastCheckIn('Car Service')
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        let values = ""
        let names = []
        if (taggedAlonedReportee !== [] && taggedAlonedReportee !== '' && taggedAlonedReportee.length > 0) {
            taggedAlonedReportee.map((val, i) => {
                names[i] = val?.name
                if (i === 0) {
                    values = val.id
                } else {
                    values += ',' + val.id
                }
            })
        }
        handleInput('tagged_along', values, '', '');
    }, [taggedAlonedReportee])


    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityResponse?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        } else if (saveActivityResponse?.status !== undefined && saveActivityResponse?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        }
    }, [saveActivityResponse])

    useEffect(() => {
        if (isCheckoutDetails?.data !== null && isCheckoutDetails?.data !== undefined && isCheckoutDetails?.data?.check_out_lat === null
            && Object.keys(pendingActivity?.data).length === 0) {
            setOpenCheckIn(true)
            setCheckInText('Check In')
        }

        // if (pendingActivity?.data !== undefined && pendingActivity?.data?.activity_id === undefined && Object.keys(pendingActivity?.data).length > 0) {
        //     setOpenCheckIn(true)
        //     setCheckInText('Check In')
        // }
    }, [isCheckoutDetails, pendingActivity])

    useEffect(() => {

        if(pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0){
            (async () => {
                setIsActivityCreated(true)
                setIsLoading(true)
                await isCheckout(pendingActivity?.data?.id)
                setIsLoading(false)
            })()
        }
    }, [pendingActivity])
    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        list['next_activity_date'] = currentDate
        list['account_id'] = match?.params?.account_id

        if (list['next_activity_date'] === '') {
            toast.error("Please choose next activity date")
            return false
        }

        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        list['reason'] = reason
        // list['product_discussed'] = productDiscussed
        list['opportunity_id'] = match?.params?.opportunity_id
        // if (activityId !== 0) {
        //     list['id'] = activityId
        // }

        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one.")
            return false
        }
        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true)
        await activitySave(list)
        setIsLoading(false)
    }

    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined && attendance?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false)
            window.location.href = `car-service-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`
        }else{
            toast.warning(attendance?.message)
        }
    }, [attendance, pendingActivity])

    // useEffect(() => {
    //     if (tollView?.data !== undefined && tollView?.data?.longitude !== undefined &&
    //         islatlng?.lat !== undefined && islatlng?.lat !== null) {
    //         let distance = calcCrow(tollView?.data?.latitude, tollView?.data?.longitude, islatlng?.lat, islatlng?.lng)
    //         setDistance(parseFloat(distance).toFixed(2))
    //         setTimeout(() => {
    //             setIsLoading(true)
    //             setIsLoading(false)
    //         }, 1000)
    //     }
    // }, [tollView, islatlng?.lat])
    //
    // useEffect(() => {
    //     if(parseInt(distance) > 1){
    //         toast.warning("Your are outside 1km radius of the toll")
    //     }
    // }, [distance])

    const handleAddReason = () => {
        setReason([
            ...reason,
            {reason: ''}
        ])
    }

    const handleRemoveReason = (e, index) => {
        e.preventDefault()
        const list = [...reason]
        list.splice(index, 1);
        setReason(list);
    }

    // const handleAddProductDiscussed = () => {
    //     setProductDiscussed([
    //         ...productDiscussed,
    //         {product_discussed: ''}
    //     ])
    // }
    //
    // const handleRemoveProductDiscussed = (e, index) => {
    //     e.preventDefault()
    //     const list = [...productDiscussed]
    //     list.splice(index, 1);
    //     setProductDiscussed(list);
    // }
    //
    // const handleProductDiscussed = (val, i, e) => {
    //     let list = [...productDiscussed]
    //
    //     let isProduct = false
    //     productDiscussed.map((value, i) => {
    //         if(value?.product_discussed === val){
    //             isProduct = true
    //         }
    //     })
    //     if(isProduct){
    //         handleRemoveProductDiscussed(e, i)
    //         toast.warning(val+" already added")
    //         return false
    //     }
    //
    //     list[i]['product_discussed'] = val
    //     setProductDiscussed(list)
    // }

    const handleReason = (val, i, e) => {
        let list = [...reason]

        let isProduct = false
        reason.map((value, i) => {
            if(value?.reason === val){
                isProduct = true
            }
        })
        if(isProduct){
            handleRemoveReason(e, i)
            toast.warning(val+" already added")
            return false
        }

        list[i]['reason'] = val
        setReason(list)
    }

    useEffect(() => {

        if(lastCheckInRes?.client_name !== undefined){
            setLastCheckInUrl("Please checkout from "+lastCheckInRes?.client_name+" before creating new checkin")
        }
    }, [lastCheckInRes])

    useEffect(() => {
        if(currentLocation?.is_mock){
            setOpenCheckIn(false)
            setHideCheckIn(true)
            setIsMockLocation(true)
            handleErrorLogsSave(`"Location morphing is cheating. ${checkInText} not allowed"`, checkInText);
            setCountToOpenModal(countToOpenModal+1);
        }
    }, [currentLocation]);

    const handleErrorLogsSave = async (msg, type) => {
        setIsLoading(true)
        await errorLogs({
            module_type:"Car service",
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        });
        setIsLoading(false)
    }
    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`car-service-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
                // url={backUrl}
            />

            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={`car-service-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
                />
            }
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ? <div className="popup-box">
                                    <div className="box">
                                        <DistanceCalculator
                                            isMapShow={true}
                                            calculateDistance={markAttendance}
                                            moduleType={'Car Service'}
                                            checkInText={checkInText}
                                            checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                            activityId={isCheckoutDetails?.data?.activity_id !== undefined ? isCheckoutDetails?.data?.activity_id : ""}
                                            accountId={isCheckoutDetails?.data?.account_id !== undefined ? isCheckoutDetails?.data?.account_id : ""}
                                            documentUploadUrlPublic={documentUploadUrlPublic}
                                            documentUrlDataPublic={documentUrlDataPublic}
                                            deviceIdCheck={true}
                                            hideCheckButton={hideCheckIn}
                                        />
                                    </div>
                                </div>
                                :
                            <>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">
                                                    <marquee behavior="rtl"><span style={{color:"indianred"}}>{lastCheckInUrl}</span>
                                                    </marquee>

                                                </h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-sm-6 mt-1 float-field"
                                                             style={{marginTop: "16px !important"}}>
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    handleInput('next_activity_type_id', e.target.value, e)
                                                                    setActivityTypeId(e.target.value)
                                                                }} required>
                                                                <option value="">Select Activity</option>
                                                                {types && types?.data !== undefined && types?.data.map((val) => {
                                                                    return (
                                                                        <>
                                                                            <option
                                                                                value={val?.id}>{val.name}
                                                                            </option>
                                                                        </>
                                                                    )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Schedule Activity
                                                            </label>
                                                        </div>
                                                        {/*{parseInt(activityTypeId) === 31 &&*/}
                                                        {/*    productDiscussed.map((val, i) => {*/}
                                                        {/*        return (*/}
                                                        {/*            <>*/}
                                                        {/*                <div className="col-sm-6 mt-1 float-field" key={i}>*/}
                                                        {/*                    <select*/}
                                                        {/*                        className="form-control form-control-user"*/}
                                                        {/*                        onChange={(e) => {*/}
                                                        {/*                            handleProductDiscussed(e.target.value, i, e)*/}
                                                        {/*                        }}*/}
                                                        {/*                        required*/}
                                                        {/*                    >*/}
                                                        {/*                        <option value="">Select Products Discussed*/}
                                                        {/*                        </option>*/}
                                                        {/*                        <option value={"Payment Follow-up"}>Payment Follow-up*/}
                                                        {/*                        </option>*/}
                                                        {/*                        <option*/}
                                                        {/*                            value={"Driver/Rides Discussion"}>Driver/Rides Discussion*/}
                                                        {/*                        </option>*/}
                                                        {/*                        <option*/}
                                                        {/*                            value={"Leads Discussion"}>Leads Discussion*/}
                                                        {/*                        </option>*/}
                                                        {/*                        <option*/}
                                                        {/*                            value={"Offline Marketing"}>Offline Marketing*/}
                                                        {/*                        </option>*/}
                                                        {/*                    </select>*/}
                                                        {/*                    <label className="large-label float-lb">*/}
                                                        {/*                        Products Discussed*/}
                                                        {/*                    </label>*/}
                                                        {/*                </div>*/}
                                                        
                                                        {/*                <div className="btn-box mb-2">*/}
                                                        {/*                    {productDiscussed.length !== 1 &&*/}
                                                        {/*                        <>*/}
                                                        {/*                            <button*/}
                                                        {/*                                onClick={(e) => handleRemoveProductDiscussed(e, i)}*/}
                                                        {/*                                className="btn btn-sm btn-danger ml-3 btn-ar">Remove Products Discussed*/}
                                                        {/*                            </button>*/}
                                                        {/*                        </>*/}
                                                        {/*                    }*/}
                                                        {/*                    {productDiscussed.length - 1 === i &&*/}
                                                        {/*                        <button type="button"*/}
                                                        {/*                                className="btn btn-sm btn-primary ml-3 btn-ar"*/}
                                                        {/*                                onClick={() => handleAddProductDiscussed()}>Another Products Discussed*/}
                                                        {/*                        </button>}*/}
                                                        {/*                </div>*/}
                                                        {/*            </>*/}
                                                        {/*        )*/}
                                                        {/*    })*/}
                                                        {/*}*/}
                                                        <div className="col-sm-6 mtk-075 float-field">
                                                            <input type="datetime-local"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('next_activity_date', e.target.value, e)
                                                                       setCurrentDate(e.target.value)
                                                                   }}
                                                                   my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                                                   id="validationCustom01"
                                                                   min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                   value={currentDate}
                                                                   required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Activity Date
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <DropDownInput
                                                                data={senior}
                                                                label={'Tagged Along'}
                                                                getIdValue={(val) => {
                                                                    setTaggedAlonedReportee(val)
                                                                }}
                                                                multipule={true}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                {/*Description*/}
                                                            </label>
                                                        </div>

                                                        {reason.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="col-sm-6 mt-1 float-field">
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleReason(e.target.value, i, e)
                                                                            }}
                                                                            required
                                                                        >
                                                                            <option value="">Select Reason
                                                                            </option>
                                                                            <option value={"Initial Meeting"}>Initial Meeting
                                                                            </option>
                                                                            <option
                                                                                value={"Proposal Shared"}>Proposal Shared
                                                                            </option>
                                                                            <option
                                                                                value={"Demo session"}>Demo session
                                                                            </option>
                                                                            <option
                                                                                value={"Proposal Discussion "}>Proposal Discussion
                                                                            </option>
                                                                            <option
                                                                                value={"Commercial negotiation"}>Commercial negotiation
                                                                            </option>
                                                                            <option
                                                                                value={"Agreement Shared"}>Agreement Shared
                                                                            </option>
                                                                            <option
                                                                                value={"Agreement Signed"}>Agreement Signed
                                                                            </option>
                                                                            <option
                                                                                value={"Closure"}>Closure
                                                                            </option>
                                                                            <option
                                                                                value={"General Business Review"}>General Business Review
                                                                            </option>
                                                                        </select>
                                                                        <label className="large-label float-lb">
                                                                            Reason
                                                                        </label>
                                                                    </div>

                                                                    {/*<div className="btn-box mb-2">*/}
                                                                    {/*    {reason.length !== 1 &&*/}
                                                                    {/*        <>*/}
                                                                    {/*            <button*/}
                                                                    {/*                onClick={(e) => handleRemoveReason(e, i)}*/}
                                                                    {/*                className="btn btn-sm btn-danger ml-3 btn-ar">Remove Reason*/}
                                                                    {/*            </button>*/}
                                                                    {/*        </>*/}
                                                                    {/*    }*/}
                                                                    {/*    {reason.length - 1 === i &&*/}
                                                                    {/*        <button type="button"*/}
                                                                    {/*                className="btn btn-sm btn-primary ml-3 btn-ar"*/}
                                                                    {/*                onClick={() => handleAddReason()}>Another Reason*/}
                                                                    {/*        </button>}*/}
                                                                    {/*</div>*/}
                                                                </>
                                                            )
                                                        })
                                                        }
                                                        {/*<div className="col-sm-12 mtk-1 float-field mb-3 d-mtk-2">*/}
                                                        {/*    <FileUpload*/}
                                                        {/*        id={"addAttachment"}*/}
                                                        {/*        accept=".png,.jpg,.jpeg"*/}
                                                        {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                                        {/*        documentUrlData={documentUrlDataPublic}*/}
                                                        {/*        onChange={(e, val) => {*/}
                                                        {/*            handleInput('meta_data', e, 'Document', e)*/}
                                                        {/*        }}*/}
                                                        {/*        prefilledFilename={""}*/}
                                                        {/*        multiple={true}*/}
                                                        {/*    >*/}
                                                        {/*        File Attachment*/}
                                                        {/*    </FileUpload>*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                            </div>
                                            {/*</div>*/}
                                            <div className="col-md-12 mt-4 d-flex">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CarServiceActivitySave

